import React, { useEffect, useState } from "react";
import { configState } from "../../../context/configState";
import { CoinButton } from "../buttons/CoinButton";
import { useRecoilValue } from "recoil";
import { walletState } from "../../../context/walletState";

import GetBalance from "../balance/GetBalance";
import SwapHeaderMenu from "../../swap/SwapHeaderMenu";
import FavouriteCoin from "./FavouriteCoin";
import { favourites } from "../../../context/Favourites";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import ToggleSwitch from "./ToggleSwitch";

const CoinSelect = ({
  coinSelected,
  disabledCoin,
}: {
  coinSelected: React.MouseEventHandler<HTMLDivElement>;
  disabledCoin: String;
}) => {
  const { assetsMap } = useRecoilValue(configState);
  let assets = Object.keys(assetsMap);
  const { address } = useRecoilValue(walletState);
  const [text, setText] = useState("");
  const handleCoinSelect = (asset: any) => {
    coinSelected(asset);
  };

  const frequent = ["sSCRT", "sATOM"];
  const fav = useRecoilValue<any>(favourites);
  const [activeMenu, setActiveMenu] = useState("All");


  const handleClick = () =>{
    activeMenu ==="All" ? 
    setActiveMenu("MyList") : 
    setActiveMenu("All");
  }

  return (
    <div className="coin-select-container">
      <div className="coin-select-header">
        Select a Coin
        {/* <span className="material-symbols-outlined">close</span> */}
      </div>
      <div className="coinSearch poolSearch">
        {/* search */}
        <div>
          <FontAwesomeIcon icon={faSearch} />
        </div>
        <input
          type="text"
          placeholder="Enter the token symbol or address"
          value={text}
          onChange={(e) => setText(e.target.value)}
          autoFocus={true}
        />
      </div>
      <div className="frequent-tokens">
        {frequent.map((asset, index) => {
          return (
            <div className="frequent-token-wrap" key={index+"1"}>
              <CoinButton
                id={index}
                coinName={assetsMap[asset].name}
                displayDenom={assetsMap[asset].display_denom}
                logoUrl={assetsMap[asset].logo_URIs.png}
                onClick={() => handleCoinSelect(asset)}
                key={`coin ${index}`}
                showName={false}
              />
            </div>
          );
        })}
      </div>
      <div className="coin-select-input-head">
        {/* <SwapHeaderMenu
          activeMenu={activeMenu}
          onClick={() => setActiveMenu("All")}
          name={"All"}
        />
        <SwapHeaderMenu
          activeMenu={activeMenu}
          onClick={() => setActiveMenu("MyList")}
          name={"MyList"}
        /> */}
        <ToggleSwitch label="Show Favourites" handleClick={handleClick}/>
      </div>
      <div className="coin-select-input-wrapper">
        {(activeMenu === "All" ? assets : fav)
          .filter((val: any) => {
            if (assetsMap[val] === undefined || assetsMap[val] === null)
              return null;
            if (text === "") {
              return val;
            } else if (
              assetsMap[val].display_denom
                .toLowerCase()
                .includes(text.toLowerCase())
            ) {
              return val;
            }
          })
          .map((asset: any, index: any) => {
            if (asset === disabledCoin) return null;
            return (
              <div className="coin-select-input-element" key={index+"2"} onClick={() => handleCoinSelect(asset)}>
                <div className="coin-select-input-element-coin">
                  <FavouriteCoin coin={asset} />
                  <CoinButton
                    coinName={assetsMap[asset].name}
                    displayDenom={assetsMap[asset].display_denom}
                    logoUrl={assetsMap[asset].logo_URIs.png}
                    onClick={() => handleCoinSelect(asset)}
                    key={`coin ${index}`}
                    showName={false}
                  />
                </div>

                <div className="coin-select-input-element-balance">
                  {!address ? (
                    // <button>Get Balance</button>
                    "-"
                  ) : (
                    <GetBalance token={asset} fetchBal={() => {}} />
                  )}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default CoinSelect;
